import type { IntakeAnswers, IntakeQuestion } from "./types";

export const HEIGHT_KEY = "observation.height_inches";
export const WEIGHT_KEY = "observation.current_weight_lbs";
export const inchesToCm = (inches: number) => inches * 2.54;
export const cmToInches = (cm: number) => cm / 2.54;
export const poundsToKg = (pounds: number) => pounds * 0.45359237;
export const kgToPounds = (kg: number) => kg / 0.45359237;

export function intakeBmi(
  answers: IntakeAnswers,
  questions: IntakeQuestion[],
): number | null {
  const height = answers[HEIGHT_KEY];
  const weight = answers[WEIGHT_KEY];
  if (
    typeof height !== "number" ||
    typeof weight !== "number" ||
    !Number.isFinite(height) ||
    !Number.isFinite(weight) ||
    height <= 2 ||
    height >= 100 ||
    weight <= 0
  )
    return null;
  for (const key of [HEIGHT_KEY, WEIGHT_KEY]) {
    const question = questions.find((item) => item.key === key);
    const value = answers[key] as number;
    if (
      !question ||
      (question.min != null && value < question.min) ||
      (question.max != null && value > question.max)
    )
      return null;
  }
  return poundsToKg(weight) / (inchesToCm(height) / 100) ** 2;
}
